// Note: Install React Query 
// npm install @tanstack/react-query

import axiosInstance from '@/lib/api-client';
import { ExtractedData } from '../components/cv-upload/types';
import { API_ENDPOINTS } from '@/lib/api-endpoint';

// Mock delay helper for simulating API calls
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// Function to process CV file and extract data
export const processCV = async (file: File): Promise<{
  success: boolean;
  data: ExtractedData | null;
  error?: string;
}> => {
  try {
    // Simulate API upload delay
    await delay(2000);

    // Simulate AI OCR processing
    await delay(3000);

    // Mock extracted data with some missing fields
    const mockData: ExtractedData = {
      name: "Nguyen Van A",
      birthYear: 1990,
      email: "nguyenvana@example.com",
      phone: "0123456789",
      position: "Frontend Developer",
      level: "Senior",
      yearsOfExperience: 5,
      managementExperience: 2,
      languages: [
        { language: "English", level: 3 },
        { language: "Vietnamese", level: 5 }
      ],
      preferredLocation: "Ho Chi Minh City",
      experience: ["3 years as Frontend Developer", "2 years as UI/UX Designer"],
      education: ["Bachelor of Computer Science"],
      skills: ["React", "JavaScript", "TypeScript", "UI/UX Design"],
      missingFields: ["address", "certifications"],
    };

    return {
      success: true,
      data: mockData,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error instanceof Error ? error.message : 'Unknown error during CV processing',
    };
  }
};

// Function to save CV data to the backend
export const saveCV = async (data: ExtractedData): Promise<{
  success: boolean;
  error?: string;
}> => {
  await axiosInstance.post(API_ENDPOINTS.CANDIDATE, data);

  return { success: true };
}; 